import React, { useState } from 'react';
import {
    Dialog,
    Box,
    Typography,
    Button,
    IconButton,
    OutlinedInput,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

import get from "lodash/get";
import filter from "lodash/filter";
import map from "lodash/map";
import trim from "lodash/trim";
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from "react-redux";
import Question from "../../../components/form/Question"

import Table from "../../../components/form/Table";


const DriverModal = ({
    __,
    open,
    close,
    id,
    callback
}) => {

    const dispatch = useDispatch();
    const [searchValue, setSearchValue] = useState("");
    const [openQuestion, setOpenQuestion] = useState({
        value: "",
        state: false
    });

   
    const [selected, setSelected] = useState({})
    const [showNoti, setShowNoti] = useState({ open: false, msg: "", variant: "error", action: "post" })

    const onChange = (e) => {
        setSearchValue(trim(e.target.value))
    }

    const driversAll = useSelector(state => state.masters.driver); 

    const onAdd = () => {
        (get(selected, "name"))
        setSelected({})
        callback(openQuestion.value)
        setOpenQuestion(prev => ({ ...prev, state: false}))
      }
    
    const headTable = [
        {
            key: "Button",
            label: "Seleccionado",
            align: "center",
            width: 70,
        },
        {
            key: "nameProvider",
            label: __(`table.colsDriver.provider`),
            align: "center",
        },
        {
            key: "name",
            label: __(`table.colsDriver.name`),
            align: "center"
        },
        {
            key: "license",
            label: __(`table.colsDriver.license`),
            align: "center"
        },
        {
            key: "dateExpire",
            label: __(`table.colsDriver.dateExpire`),
            align: "center"
        },
    ]

    const dataTable = map(get(driversAll, "data.data", []), (row, i) => {
        const labelId = `enhanced-table-checkbox-${i}`;
        
        return ({
            ...row,
            Button: (
                <Button
                name="btnDriver"  
                onClick={()=>{ {setOpenQuestion(prev => ({ ...prev, state: true, value: row }))}}}         
                inputProps={{ 'aria-labelledby': labelId }}
                variant="contained"  
                color="primary"
                >
                Agregar
                </Button>
            ),
            dateExpire: new Date(get(row, "dateExpire")).toISOString().split('T')[0],
        })
      })

    
    return (
        <Dialog close={close} open={open} maxWidth="lg" fullWidth>
                <Box>
                    <IconButton
                        aria-label="close"
                        onClick={close}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>
                <Box className='px-6'>
                    <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
                        {__(`labels.12`)}
                    </Typography>
                </Box>
                <Box className='flex flex-col justify-center m-6'>
                    {/* <div className='px-8 pyt-2'>
                        <OutlinedInput
                            id="search-btn"
                            endAdornment={
                                <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
                                    <SearchIcon />
                                </IconButton>
                            }
                            aria-describedby="outlined-weight-helper-text"
                            inputProps={{
                                'aria-label': 'weight',
                            }}
                            size="small"
                            fullWidth
                            onChange={onChange}
                            placeholder={__("action.search")}
                        />
                    </div>     */}
                    <div className='px-8 pyt-2 pt-3'>
                        <Table headTable={headTable}
                            dataTable={dataTable}
                            __={__}
                            sizeFilters={125}
                            empty="drivers"
                        />
                    </div>
                    <Question
                        title={__("alert.addDriver")}
                        detail={__("alert.addDriverDetail")}
                        onSuccess={onAdd}
                        onCancel={() => setOpenQuestion(prev => ({ ...prev, state: false}))}
                        open={openQuestion.state}
                    />
                </Box>
            </Dialog>
    );
}

export default DriverModal